import React from 'react'

function InstaDefault() {

  return (
    <div className=" py-5  ">

    </div>
  )
}

export default InstaDefault